module.exports = __webpack_public_path__ + "media/images/game/categories/zdravi_a_sport-3829a2bf3cd35c1edbcbd15dfd53c319.png";